<template>
    <v-card
            width="115"
            elevation="3"
            max-width="300"
            @click="this.dispatchClick"
            :color="getBoarderColor()"
    >
        <v-row justify="center"
               class="spacing-playground pa-1"
        >
          <v-img
              :src="getItemIcon()"
              max-width="85px"
              max-height="85px"
              dark
              class="mt-3"
          >
              <v-checkbox
                  v-if="!isIconGroupReady"
                  v-model="isMark"
                  class="pl-0 pt-15 mt-0 ml-0"
              ></v-checkbox>
          </v-img>
          
          <v-chip
              v-if="isIconGroupReady"
              class="ma-4"
              color="green darken-2"
              text-color="white"
          >
            <div class="text-lg-button">
              Group: {{this.iconData.groupId}}
            </div>
          </v-chip>
          <v-chip
              v-else
              class="ma-4"
              color="grey darken-3"
              text-color="deep-orange lighten-4"
          >
            No Group
          </v-chip>
        </v-row>
    </v-card>
</template>

<script>
// import {EVENT_TO_OPEN_ITEM_FORM, EVENT_TO_OPEN_SIBLING_ITEM_FORM, GlobalEvents} from "@/item-editor/events/GlobalEvents";

    export default {
        name: "TransformIconListCardItem.vue",
        props:{
            'pIconData':{
                required: true
            },
            'pFromSibling':{
                type: Boolean,
                default: false,
                required: false
            },
        },
        data() {
            return {
                iconData: null,
                isMark: false
            }
        },
        created() {
            this.iconData = this.pIconData;
            this.isMark = this.iconData.isMark;
        },
        methods: {
            dispatchClick() {
                if(!this.isIconGroupReady){
                     this.iconData.isMark = !this.iconData.isMark;
                    this.isMark = this.iconData.isMark;
                    this.$emit("OnMarkedChange");
                }
            },
            getItemIcon() {
                return require('../../assets/weapons/textures/' + this.iconData.name);
            },
            getBoarderColor(){
                if(this.iconData.isCurrentSelect){
                    return "green";
                }
                return "grey darken-4";
            },
        },
        computed:{
            isIconGroupReady(){
                return this.iconData.groupId > 0;
            }
        },
        watch: {
            pIconData(newVal, oldVal){
                if (oldVal) {
                    // optional: clean up or nullify old references
                    oldVal = null;
                    this.isMark = newVal.isMark;
                }
            }
        },
    }
</script>

<style scoped>
    .v-list--two-line .v-list-item,
    .v-list-item--two-line {
        min-height: 30px;
        height:30px;
    }
</style>